export var cardDesktopWidth = '1020px';
export var cardDesktopHeight = '232px';
export var cardTabletWidth = '720px';
export var cardTabletHeight = '187px';
export var cardMobileHeight = '380px';
export var desktopImageWidth = '320px';
export var desktopImageHeight = '232px';
export var tabletImageWidth = '272px';
export var tabletImageHeight = '187px';
export var mobileImageHeight = '200px';
export var smallFontSize = '14px';
export var fakeCarouselDotBorderColour = '#fff';
export var fakeCarouselDotFontSize = 0;